/* ============================================================
   SOLARA MOTION
   Drives the visuals rendered by snippets/solara-visual-*.liquid.
   - [data-smo="reveal"]   animates once when scrolled into view
                           (scales, price chart, weight bar), and counts
                           up any [data-smo-count] figures inside it.
   - [data-smo="diagram"]  heat-loss diagram: bare ground / mat toggle,
                           one opening sequence, ambient loops while on screen.
   Motion only runs when the visual has data-smo-motion and the visitor
   hasn't asked for reduced motion. Safe to load more than once.
   ============================================================ */
(function () {
  if (window.SolaraMotion) {
    window.SolaraMotion.scan(document);
    return;
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  var fmtMoney = function (cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0
      ? d.toLocaleString('en-AU')
      : d.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  };

  var countUp = function (el) {
    if (el.getAttribute('data-smo-counted')) return;
    el.setAttribute('data-smo-counted', '1');
    var target = parseFloat(el.getAttribute('data-smo-count'));
    if (!target || !window.requestAnimationFrame) return;
    var finalText = el.textContent;
    var money = el.getAttribute('data-smo-format') === 'money';
    var suffix = el.getAttribute('data-smo-suffix') || '';
    var delay = parseInt(el.getAttribute('data-smo-delay'), 10) || 0;
    var duration = 1300;
    var start = null;
    var tick = function (ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var v = target * (1 - Math.pow(1 - p, 3));
      el.textContent = money ? fmtMoney(Math.round(v / 100) * 100) : Math.round(v).toLocaleString('en-AU') + suffix;
      if (p < 1) {
        window.requestAnimationFrame(tick);
      } else {
        el.textContent = finalText;
      }
    };
    el.textContent = money ? fmtMoney(0) : '0' + suffix;
    setTimeout(function () { window.requestAnimationFrame(tick); }, delay);
  };

  var wantsMotion = function (el) {
    return el.hasAttribute('data-smo-motion') && !reduce && hasIO;
  };

  var revealObserver = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('is-in');
      el.querySelectorAll('[data-smo-count]').forEach(countUp);
      revealObserver.unobserve(el);
    });
  }, { threshold: 0.3 }) : null;

  var setupReveal = function (el) {
    if (wantsMotion(el)) {
      revealObserver.observe(el);
    } else {
      el.classList.add('is-in');
    }
  };

  var setupDiagram = function (dg) {
    var seg = dg.querySelector('.smo-seg');
    var btns = dg.querySelectorAll('[data-smo-state]');
    var status = dg.querySelector('[data-smo-status]');
    var touched = false;
    var setState = function (st) {
      dg.setAttribute('data-state', st);
      btns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-smo-state') === st ? 'true' : 'false');
      });
      if (status) status.textContent = status.getAttribute('data-' + st) || '';
    };
    if (seg) seg.hidden = false;
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        touched = true;
        setState(b.getAttribute('data-smo-state'));
      });
    });
    if (!wantsMotion(dg)) return;

    /* Opening sequence: start on bare ground, then slide the mat in */
    setState('bare');
    var sequenced = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        dg.classList.toggle('is-playing', e.isIntersecting);
        if (e.isIntersecting && !sequenced) {
          sequenced = true;
          setTimeout(function () {
            if (!touched) setState('mat');
          }, 2600);
        }
      });
    }, { threshold: 0.35 });
    io.observe(dg);
  };

  var scan = function (scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-smo]').forEach(function (el) {
      if (el.__smo) return;
      el.__smo = true;
      if (el.getAttribute('data-smo') === 'diagram') {
        setupDiagram(el);
      } else {
        setupReveal(el);
      }
    });
  };

  window.SolaraMotion = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
